<template>
  <div class="home-container bc-bgc">
    <van-nav-bar class="nav-bar" fixed placeholder>
      <template #title>
        <img
          :src="
            $store.getters.getBaseInfo.ico !== undefined
              ? $store.getters.getBaseInfo.ico
              : '/img/null.png'
          "
          class="titleimg"
        />
      </template>
      <template #right>
        <div
          v-if="!is_login"
          class="m-md2-r ps3"
          @click="$router.push('/Register')"
        >
          <span>{{ $t("auth.no_account") }}</span>
        </div>
        <img
          @click="kefu()"
          class="w2 bc-w1"
          src="../../assets/bc-img/tall.png"
          alt=""
        />
      </template>
    </van-nav-bar>
    <div class="home-scroll">
      <!-- 轮播 -->
      <!-- <div class="banner">
        <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v, key) in banners" :key="key">
            <van-image class="banner_img" round :src="v.url">
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
      </div> -->
      <!-- 公告 -->
      <!-- <div class="notice-bar">
        <van-notice-bar
          class="notice-swipe"
          left-icon="volume-o"
          background="linear-gradient(to right,#332022,#271C2D)"
          color="#e7b58e"
          :text="this.notice"
        />
        <div class="linear-gradient"></div>
      </div> -->
      <!-- <ul class="index-nav m-flex m-f-top">
        <li
          @click="key != 5 ? $router.push(item.path) : toServicePage()"
          v-for="(item, key) in indexNav"
          :key="key"
        >
          <img :src="item.icon" alt="" />
          <p>{{ item.text }}</p>
        </li>
      </ul> -->
      <!-- 精选、焦点、客服入口 -->
      <!-- <div class="m-flex m-f-top bc-flex">
        <div class="bc-choose">
          <div>{{ $t("index.Featured") }}</div>
          <div style="color: #fff; font-size: 1.3rem">
            {{ recommend.hot_count }}
          </div>
          <div
            style="
              color: #ccc;
              font-weight: lighter;
              font-size: 0.6rem !important;
            "
          >
            {{ $t("index.more") }}
          </div>
        </div>
        <div class="bc-choose">
          <div>{{ $t("index.focus") }}</div>
          <div style="color: #fff; font-size: 1.3rem">
            {{ recommend.recommend_count }}
          </div>
          <div
            style="
              color: #ccc;
              font-weight: lighter;
              font-size: 0.6rem !important;
            "
          >
            {{ $t("index.hot") }}
          </div>
        </div>
        <div class="bc-choose">
          <div>{{ $t("index.Entrance") }}</div>
          <div
            style="
              color: #fff;
              font-weight: lighter;
              font-size: 0.6rem !important;
            "
          >
            {{ $t("index.customer_service") }}
          </div>
          <button class="btn" @click="kefu()">
            {{ $t("index.contact") }}
          </button>
        </div>
      </div> -->
      <!-- 人气排行 -->
      <!-- <van-pull-refresh
        :pulling-text="$t('reservation.refresh')"
        :loosing-text="$t('reservation.refreshpage')"
        :loading-text="$t('reservation.refresh')"
        :success-text="$t('reservation.refresh')"
        v-model="isLoading"
        @refresh="onRefresh"
      > -->
      <!-- <div class="hot-recommend">
          <div class="hot-title">{{ $t("index.Featured_list") }}</div>
          <div class="hot-title-div">
            <div>
              <span>{{ $t("index.hot") }}</span>
            </div>
            <div class="hot-right">
              <span @click="gotoMenu('/Choose')">{{
                $t("index.recmonmand")
              }}</span>
              <van-icon name="arrow" color="#979799" />
            </div>
          </div> -->

      <!-- 核心：一行4个，仅显示2排（共8个） -->
      <!-- <div class="movie_list_0">
            <div
              class="movie-item"
              v-for="(v, key) in visibleFeaturedList"
              :key="key"
              @click="profile(v.id)"
            >
              <van-image
                class="movie-img"
                :src="v.img_url"
                fallback="/img/null.png"
              >
                <template v-slot:loading>
                  <van-loading type="circular" />
                </template>
              </van-image>
              <div class="name-text2">
                {{ $t("index.airborne") }}
              </div>
              <div class="name-text">
                {{ v.xuanfei_name || $t("No information yet") }}
              </div>
            </div>
          </div> -->
      <!-- 约炮推荐 -->
      <!-- <div class="hot-title">{{ $t("index.Private") }}</div>
          <div class="hot-title-div">
            <div>
              <span>{{ $t("index.more") }}</span>
            </div>
          </div>

          <div class="movie_list_1">
            <div
              class="movie-list-item"
              v-for="(v, key) in visiblePrivateList"
              :key="key"
              @click="toPlayVideo(v.id)"
            >
              <div class="renzheng">
                <span><img src="../../assets/bc-img/V.png" alt="" /></span
                >{{ $t("index.Certification") }}
              </div>
              <van-image class="cover_img" round :src="v.img_url">
                <template v-slot:loading>
                  <van-loading type="circular" />
                </template>
              </van-image>
              <p class="text-line2">{{ v.xuanfei_name }}</p>
            </div>
            <div class="hot-recommend-more" @click="nextList">
              {{ $t("index.next") }}
            </div>
          </div>
        </div>
      </van-pull-refresh> -->
      <!-- 顶部导航栏 -->
      <div class="top-nav">
        <div
          v-for="(item, index) in topNav"
          :key="item.id || index"
          :class="['nav-item', { active: activeNav === index }]"
        >
          <span @click="setActiveNav(index)">{{ item.name }}</span>
          <van-icon
            v-if="item.subItems && item.subItems.length && activeNav === index"
            name="arrow-down"
            :class="['dropdown-icon', { rotate: showCategories }]"
            @click.stop="toggleDropdown(index)"
          />
        </div>
      </div>

      <!-- 分类标签 -->
      <div v-if="showCategories" class="category-tabs">
        <div
          v-for="(category, index) in currentCategories"
          :key="category.id || index"
          :class="['category-item', { active: activeCategory === index }]"
          @click="setActiveCategory(index)"
        >
          {{ category.name }}
        </div>
      </div>

      <!-- 直播列表 -->
      <!-- @click="enterLiveRoom(v.id)" -->
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        :finished-text="$t('video.no_more')"
        @load="onLoad"
      >
        <div class="movie_list_0">
          <div
            class="movie-item"
            v-for="(v, key) in xuan_fei"
            :key="key"
            @click="kefu()"
            @mouseenter="handleMouseEnter(key)"
            @mouseleave="handleMouseLeave(key)"
            @touchstart="handleTouchStart(key, $event)"
            @touchend="handleTouchEnd(key)"
          >
            <van-image
              class="movie-img"
              lazy-load
              :src="v.vod_pic"
              fallback="/img/null.png"
              :class="{ hide: playingVideo === key }"
            >
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
            <video
              ref="videoRefs"
              :class="{ 'movie-img': true, show: playingVideo === key }"
              :src="v.vod_play_url"
              autoplay
              muted
              loop
              playsinline
            ></video>
            <div class="live-tag live">
              <img src="../../assets/bc-img/liveing.png" alt="" />
            </div>
            <div class="live-viewers">
              <van-icon name="contact-o" /> {{ v.vod_live_num || 0 }}
            </div>
            <div class="live-username">
              {{ v.vod_name || v.vod_name_yn_yu || $t("No information yet") }}
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'Home',
  data() {
    return {
      loggedIn: !!localStorage.getItem("token"),
      notice: this.$t("index.loading"),
      banners: [{}],
      basicData: [],
      gameitem: [{}, {}, {}, {}],
      movielist_0: [{}, {}, {}, {}],
      movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}],
      isLoading: false,
      movielistSwiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "1",
        speed: 800,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
      xuan_fei: [],
      choose_page: 1,
      datalist: [],
      num: 4,
      hot_list: [], //热门列表
      recommend: [], //推荐列表
      testlist: [],
      // 顶部导航栏数据
      topNav: [],
      // 分类标签数据
      categories: [],
      // 状态数据
      activeNav: 0, // 默认选中附近
      activeCategory: 0, // 默认选中全部
      showCategories: false, // 分类标签显示状态（默认收起）
      // 直播列表数据
      videolitem: [],
      videoPage: 1,
      videoCount: 0,
      loading: false,
      finished: false,
      // 视频播放状态
      playingVideo: null,
      touchTimer: null,
    };
  },
  computed: {
    is_login() {
      return this.loggedIn;
    },
    visibleFeaturedList() {
      return Array.isArray(this.xuan_fei) ? this.xuan_fei.slice(0, 10) : [];
    },
    visiblePrivateList() {
      return Array.isArray(this.datalist)
        ? this.datalist.slice(0, this.num)
        : [];
    },
    indexNav() {
      return {
        1: {
          icon: "/img/index_nav/0.png",
          text: this.$t("foorter.subscribe"),
          path: "/Game",
        },
        2: {
          icon: "/img/index_nav/1.png",
          text: this.$t("bulletin"),
          path: "/Notice",
        },
        3: {
          icon: "/img/index_nav/2.png",
          text: this.$t("foorter.Film"),
          path: "/Video",
        },
        4: {
          icon: "/img/index_nav/3.png",
          text: this.$t("concubine.concubine"),
          path: "/Choose",
        },
      };
    },
    // 当前分类标签数据
    currentCategories() {
      // 根据当前选中的导航项返回对应的子分类
      if (!Array.isArray(this.topNav) || !this.topNav[this.activeNav]) {
        return [];
      }
      return this.topNav[this.activeNav].subItems || [];
    },
  },
  methods: {
    updateLoginState() {
      this.loggedIn = !!localStorage.getItem("token");
    },
    buildVideoNav(categories) {
      return (Array.isArray(categories) ? categories : []).map((item) => ({
        id: item.id,
        name: item.name,
        subItems: Array.isArray(item.children) ? item.children : [],
      }));
    },
    getActiveClassId() {
      const currentNav = this.topNav[this.activeNav];
      if (!currentNav) {
        return 0;
      }
      const currentChild = Array.isArray(currentNav.subItems)
        ? currentNav.subItems[this.activeCategory]
        : null;
      return currentChild && currentChild.id ? currentChild.id : currentNav.id;
    },
    resetHomeVideoState() {
      this.videoPage = 1;
      this.videoCount = 0;
      this.xuan_fei = [];
      this.loading = false;
      this.finished = false;
    },
    getVideoClass() {
      return this.$http({
        method: "get",
        url: "video_class",
      }).then((res) => {
        console.log("获取到的分类", res.data);
        const categories = Array.isArray(res.data) ? res.data : [];
        this.videolitem = categories;
        this.topNav = this.buildVideoNav(categories);
        if (!this.topNav.length) {
          this.activeNav = 0;
          this.activeCategory = 0;
          this.showCategories = false;
          return res;
        }
        if (!this.topNav[this.activeNav]) {
          this.activeNav = 0;
        }
        const currentNav = this.topNav[this.activeNav];
        this.activeCategory =
          currentNav.subItems && currentNav.subItems.length ? 0 : -1;
        this.showCategories = false;
        return res;
      });
    },
    getHomeVideoList() {
      const classId = this.getActiveClassId();
      if (!classId) {
        this.xuan_fei = [];
        this.videoCount = 0;
        return Promise.resolve();
      }
      return this.$http({
        method: "get",
        url: "video_list",
        data: {
          id: classId,
          page: this.videoPage,
          limit: 20,
        },
      }).then((res) => {
        console.log("直播列表", res.data.data);
        const payload = res.data || {};
        const list = Array.isArray(payload.data) ? payload.data : [];
        if (this.videoPage === 1) {
          this.xuan_fei = list;
        } else {
          this.xuan_fei.push(...list);
        }
        this.videoCount = payload.count || list.length || 0;
        this.persistHomeData();
        return res;
      });
    },
    consumeRedirectTip() {
      const { redirect_tip, redirect_ts, ...restQuery } =
        this.$route.query || {};
      if (!redirect_tip) {
        return;
      }
      this.$nextTick(() => {
        if (redirect_tip === "contact_admin") {
          this.$toast(this.$t("reservation.contact_admin"));
        }
      });
      this.$router.replace({
        path: this.$route.path,
        query: restQuery,
      });
    },
    applyCachedHomeData() {
      const cache = localStorage.getItem("home_page_cache_tw");
      if (!cache) return false;
      try {
        const parsed = JSON.parse(cache);
        this.notice = parsed.notice || this.notice;
        this.banners =
          Array.isArray(parsed.banners) && parsed.banners.length
            ? parsed.banners
            : this.banners;
        this.xuan_fei = Array.isArray(parsed.xuan_fei) ? parsed.xuan_fei : [];
        this.datalist = Array.isArray(parsed.datalist) ? parsed.datalist : [];
        this.hot_list = Array.isArray(parsed.hot_list) ? parsed.hot_list : [];
        this.recommend = parsed.recommend || this.recommend;
        return true;
      } catch (error) {
        return false;
      }
    },
    persistHomeData() {
      localStorage.setItem(
        "home_page_cache_tw",
        JSON.stringify({
          notice: this.notice,
          banners: this.banners,
          xuan_fei: this.xuan_fei,
          datalist: this.datalist,
          hot_list: this.hot_list,
          recommend: this.recommend,
        })
      );
    },
    kefu() {
      this.$toast(this.$t("Universal.personal"));
    },
    // async getjiaodianlist() {
    //   try {
    //     const res = await axios.get(
    //       "https://admin.meetic168.us.cc/api/xuanfei/xuanfeilist",
    //       {
    //         params: {
    //           with_stats: 1,
    //           page: 1,
    //           plain_json: 1,
    //         },
    //       }
    //     );
    //     // console.log("拿到的数据", res);
    //     this.recommend = res.data.data.stats;
    //     this.persistHomeData();
    //     // console.log("111", this.recommend);
    //   } catch (err) { }
    // },
    // getxiaojielist() {
    //   return this.$http({
    //     method: "get",
    //     url: "xuanfeilist",
    //     data: {
    //       page: this.choose_page,
    //     },
    //   }).then((res) => {
    //     console.log('选妃列表',res.data);
    //     const list = Array.isArray(res.data) ? res.data : [];
    //     if (list.length > 0) {
    //       if (this.choose_page === 1) {
    //         this.datalist = list;
    //       } else {
    //         this.datalist.push(...list);
    //       }
    //       this.persistHomeData();
    //     } else {
    //       this.choose_page -= 1;
    //     }
    //   });
    // },
    profile(id) {
      this.$router.push({ path: "/profile?id=" + id });
    },
    // getxuanfeilist() {
    //   return this.$http({
    //     method: "get",
    //     url: "xuanfeilist",
    //     data: {
    //       is_ranking: 1,
    //     },
    //   }).then((res) => {
    //     console.log('小阶列表',res.data);
    //     this.xuan_fei = Array.isArray(res.data) ? res.data : [];
    //     this.hot_list = [];
    //     this.xuan_fei.forEach((v, i) => {
    //       if (v.is_hot == 1) {
    //         this.hot_list.push(v);
    //         // console.log("热门列表", this.hot_list);
    //       }
    //     });
    //     this.persistHomeData();
    //   });
    // },
    toServicePage() {
      const service = this.$store.getters.getBaseInfo;
      if (service.iskefu == 1) {
        window.location.href = service.kefu;
      }
    },
    nextList() {},
    toLottery(key, id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "/Lottery?key=" + key + "&id=" + id });
      }
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "/profile?id=" + id });
      }
    },
    async onRefresh() {
      this.choose_page = 1;
      this.num = 4;
      this.datalist = [];
      this.resetHomeVideoState();
      try {
        await Promise.all([this.getBasicConfig(), this.getVideoClass()]);
        await this.getHomeVideoList();
        this.$toast(this.$t("reservation.refresh"));
      } finally {
        this.isLoading = false;
      }
    },
    getBasicConfig() {
      return this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        // console.log('获取到的',res.data);
        this.basicData = res.data;
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
        this.getMovieList_0(this.basicData);
        this.getMovieList_1(this.basicData);
        this.persistHomeData();
        return this.getGameItem();
      });
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    getGameItem() {
      return this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        this.gameitem = res.data;
      });
    },
    getMovieList_0(data) {
      this.movielist_0 = data.movielist_0;
    },
    getMovieList_1(data) {
      this.movielist_1 = data.movielist_1;
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    gotoMenu(index) {
      this.$router.push(index);
    },
    // 设置激活的导航项
    setActiveNav(index) {
      this.activeNav = index;
      const currentNav = this.topNav[index] || {};
      this.activeCategory =
        currentNav.subItems && currentNav.subItems.length ? 0 : -1;
      this.showCategories = false;
      this.resetHomeVideoState();
      this.getHomeVideoList();
    },
    // 切换分类标签显示/隐藏
    toggleDropdown(index) {
      const currentNav = this.topNav[index];
      if (!currentNav || !currentNav.subItems || !currentNav.subItems.length) {
        return;
      }
      if (this.activeNav !== index) {
        this.activeNav = index;
        this.activeCategory = 0;
      }
      this.showCategories = !this.showCategories;
    },
    // 设置激活的分类标签
    setActiveCategory(index) {
      this.activeCategory = index;
      this.resetHomeVideoState();
      this.getHomeVideoList();
    },
    // 加载更多
    onLoad() {
      this.loading = true;
      this.videoPage += 1;
      this.getHomeVideoList().then(() => {
        this.loading = false;
        if (this.xuan_fei.length >= this.videoCount) {
          this.finished = true;
        }
      }).catch(() => {
        this.loading = false;
        this.videoPage -= 1;
      });
    },
    // 进入直播间
    enterLiveRoom(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
        return;
      }
      this.$router.push({ path: "/PlayVideo", query: { id } });
    },
    // 检查视频是否可用
    isVideoAvailable(videoUrl) {
      // 简单检查视频URL是否存在
      return videoUrl && videoUrl.trim() !== "";
    },
    // 鼠标进入事件 - 开始播放视频
    handleMouseEnter(key) {
      const videoUrl = this.xuan_fei[key] && this.xuan_fei[key].vod_play_url;
      if (this.isVideoAvailable(videoUrl)) {
        this.playingVideo = key;
        // 播放视频
        const videoElement = this.$refs.videoRefs && this.$refs.videoRefs[key];
        if (videoElement) {
          videoElement.play().catch((err) => {
            console.log("视频播放失败:", err);
            // 播放失败时恢复显示封面图
            this.playingVideo = null;
          });
        }
      }
    },
    // 鼠标离开事件 - 停止播放视频
    handleMouseLeave(key) {
      this.playingVideo = null;
      // 暂停视频
      const videoElement = this.$refs.videoRefs && this.$refs.videoRefs[key];
      if (videoElement) {
        videoElement.pause();
      }
    },
    // 触摸开始事件 - 长按开始播放视频
    handleTouchStart(key, event) {
      const videoUrl = this.xuan_fei[key] && this.xuan_fei[key].vod_play_url;
      if (!this.isVideoAvailable(videoUrl)) {
        return;
      }
      // 清除之前的定时器
      if (this.touchTimer) {
        clearTimeout(this.touchTimer);
      }
      // 设置长按定时器
      this.touchTimer = setTimeout(() => {
        this.playingVideo = key;
        // 播放视频
        const videoElement = this.$refs.videoRefs && this.$refs.videoRefs[key];
        if (videoElement) {
          videoElement.play().catch((err) => {
            console.log("视频播放失败:", err);
            // 播放失败时恢复显示封面图
            this.playingVideo = null;
          });
        }
      }, 500); // 500ms触发长按
    },
    // 触摸结束事件 - 停止播放视频
    handleTouchEnd(key) {
      // 清除定时器
      if (this.touchTimer) {
        clearTimeout(this.touchTimer);
        this.touchTimer = null;
      }
      // 停止播放视频
      this.playingVideo = null;
      const videoElement = this.$refs.videoRefs && this.$refs.videoRefs[key];
      if (videoElement) {
        videoElement.pause();
      }
    },
  },
  created() {
    this.updateLoginState();
    this.consumeRedirectTip();
    this.applyCachedHomeData();
    this.getBasicConfig();
    this.getVideoClass().then(() => {
      this.resetHomeVideoState();
      this.getHomeVideoList();
    });
  },
  activated() {
    this.updateLoginState();
  },
};
</script>

<style lang='less' scoped>
@import "@/assets/css/base.less";
::v-deep .van-list{
  padding-bottom: 6rem;
}
.wztitle {
  color: #8d793c;
  font-size: 1.5rem;
  padding-top: 2rem;
  font-weight: bolder !important;
  padding-left: 1rem;
}
.fenlei {
  display: flex;
  width: 100%;
  height: auto;
  padding: 0.5rem 0.5rem;
  align-items: center;
  justify-content: space-around;
}

.zb-flex {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

::v-deep .van-nav-bar__right {
  padding-top: 2.5rem;
}

::v-deep .van-nav-bar__title {
  padding-bottom: 4rem;
}

::v-deep .van-nav-bar__content {
  background-image: url(../../assets/bc-img/top.png);
  background-size: 100% 100%;
  height: 6rem;
}

// @notice-bar-size: 30px;
.titleimg {
  width: 96px;
  max-height: 34px;
  object-fit: contain;
  border: 0 !important;
}

::v-deep .van-notice-bar__content {
  font-size: 0.8rem;
  font-weight: lighter !important;
}

::v-deep .van-pull-refresh {
  padding-bottom: 5rem;
}

.index-nav {
  margin: @md1;
  padding: @pd1;
  height: auto;
  text-align: center;
  color: @theme2;
  border: 1px solid @theme2;
  border-radius: @br1;
  font-size: 0.8rem;

  & > li {
    flex: 1;
  }

  p {
    margin: 0;
  }

  img {
    height: 3em;
  }
}

.linear-bg {
  height: 200px;
  background: linear-gradient(270deg, #988fba, #f487e0);
}

.home-container {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
}

.bc-bgc {
  background: linear-gradient(#1a1a1a, #000000) !important;
}

// .linear-gradient {
//   width: 100%;
//   height: 2px;
//   background: linear-gradient(
//     to right,
//     rgba(126, 86, 120, 0),
//     rgb(230, 195, 161),
//     rgba(126, 86, 120, 0)
//   );
// }

::v-deep .van-notice-bar__left-icon,
.van-notice-bar__right-icon {
  min-width: 40px;
}

.notice-swipe {
  width: 100%;
  height: 85px;
  // font-size: @notice-bar-size;
  font-size: 1rem;

  ::v-deep .van-notice-bar__left-icon {
    font-size: 1.6rem;
    font-weight: lighter !important;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
}

.notice-bar {
  margin: @md1 0;
  border: 1px solid #4a4a4a;
  border-radius: 10rem;
  overflow: hidden;

  /deep/ .notice-swipe {
    height: 2.5em;
  }
}

::v-deep .van-icon-bullhorn-o::before {
  transform: scale(2.5);
}

.banner {
  width: 100%;
}

.banner_swiper {
  height: 100%;
  width: 100%;
  border-radius: 1rem;

  .swiper-slide {
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 620px;
    height: 300px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    background-color: #ffffff;
    background-position: center;
    background-size: cover;
    color: #ffffff;
  }
}

::v-deep .swiper-container-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0)
  );
}

::v-deep .swiper-container-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0)
  );
}

.banner_img {
  border-radius: 10px;
  width: 100%;
  height: 100%;
}

.hot-game {
  width: 100%;
  height: 100%;
}

.hot-title-div {
  // width: calc(100% - 50px);
  margin: 0 0.5rem;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // background-color: @theme1;
  // padding: @pd1;
}

.hot-title-div > div:first-child {
  width: 430px;
}

.hot-title-div div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.hot-title-div > div:nth-child(2) span {
  font-size: 20px;
  color: #979799;
}

.hot-title-div > div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 35px;
  font-weight: lighter !important;
  color: #fff;
}

// .hot-title-div > div:first-child span:before {
//   content: "";
//   display: block;
//   width: 5px;
//   height: 30px;
//   background-color: @theme2;
//   border-radius: 1px;
//   margin-right: 5px;
// }

.hot-game .hot-items-div {
  margin: @md1;
}

.hot-game .hot-items-div span {
  margin-top: 10px;
  font-size: 28px;
  color: @theme2;
}

.hot-recommend {
  width: 100%;
  flex: 1;

  .hot-title {
    color: #75675d;
    font-weight: lighter !important;
    font-size: 0.7rem;
    padding: 0.5rem 0.5rem 0 0.5rem;
  }

  .hot-right {
    background: linear-gradient(to bottom right, #3e2f5a, #4b3640);
    width: auto;
    display: flex;
    justify-content: center;
    padding: 0.4rem 1rem;
    border-radius: 2rem;

    span {
      color: #c6b98b !important;
      font-weight: lighter !important;
    }
  }
}

.movie_list_0 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 15px 0;
  gap: 15px;
  color: #fff;
}

.movie-item {
  width: calc(50% - 10px);
  /* 一行2个 */
  position: relative;
  margin-bottom: 130px;
}

.movie-img {
  width: 100%;
  height: 12rem;
  /* 调整图片高度，适应一行2个的布局 */
  aspect-ratio: 1/1;
  /* 1:1 比例 */
  border-radius: 1rem;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
}

.movie-item {
  position: relative;
  width: calc(50% - 10px);
  margin-bottom: 10px;
  height: 12rem;
  /* 与图片高度一致 */
}

.movie-img.hide {
  display: none;
}

.movie-img.show {
  display: block;
}

video {
  object-fit: cover;
  object-position: center;
  display: none;
  pointer-events: none;
}

video.show {
  display: block;
  pointer-events: none;
}

::v-deep .movie-img .van-image__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.name-text {
  position: absolute;
  bottom: 6px;
  left: 0;
  right: 0;
  text-align: left;
  font-size: 20px;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.8);
  z-index: 1;
  padding: 1rem 0.5rem 0.2rem 0.5rem;
}

.name-text2 {
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  text-align: left;
  font-size: 18px;
  color: #f4c491;
  z-index: 1;
  padding: 0 0.5rem;
  background-color: rgba(92, 90, 10, 0.4);
  border-radius: 2rem;
  width: 2.5rem;
  margin-left: 0.3rem;
  font-weight: lighter !important;
}

.live-tag {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 1rem;
  font-size: 0.6rem;
  font-weight: bold;
  z-index: 2;
  img {
    width: 25px;
  }
}

.live-viewers {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  color: #fff;
  font-size: 0.7rem;
  display: flex;
  align-items: center;
  padding: 0.2rem 0.5rem;
  border-radius: 1rem;
  z-index: 2;
  ::v-deep .van-icon {
    margin-right: 0.2rem;
  }
}

.live-username {
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  color: #fff;
  font-size: 0.8rem;
  padding: 0.2rem 0.5rem;
  border-radius: 1rem;
  z-index: 2;
}

.movie_list_1 {
  display: block;
  width: calc(100% - 20px);
  margin: 0 auto;
}

.movie_list_1 .movie-list-item {
  width: 100%;
  margin: @md1 0;
  color: @white;

  p {
    margin: 0;
  }

  .renzheng {
    width: 5vm;
    padding: 0.5rem 1rem;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 2rem;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    z-index: 10;
    right: 30px;
    font-weight: lighter !important;
    margin-top: 0.6rem;
    font-size: 20px;

    span {
      display: flex;
      align-items: center;
    }

    img {
      width: 30px;
    }
  }
}

.movie_list_1 .movie-list-item .cover_img {
  border-radius: 1.5rem;
  width: 100%;
  height: 400px;

  ::v-deep .van-image__img {
    object-fit: cover;
    object-position: center center;
  }
}

.home-scroll {
  // padding-bottom: 110px;
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  background-color: #201f1d !important;
}

.hot-recommend-more {
  width: 100%;
  padding-bottom: 20px;
  text-align: center;
  color: #979799;
  font-size: 30px;
}

/deep/ .van-grid-item__content {
  background-color: @theme1;
  color: @theme2;
}

::v-deep .hot-items-div .game_item_img .van-image__img {
  border-radius: 20px;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

.bc-flex {
  display: flex;
  justify-content: space-between;
  padding: 0 0.5rem;
}

.bc-w1 {
  width: 40px !important;
  height: 40px !important;
}

.bc-choose {
  width: 32%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  color: #e7a761;
  font-size: 0.7rem;
  border: 1px solid #444;
  padding: 0.8rem;
  border-radius: 1rem;
  background-color: #1a1a1a;

  .btn {
    background-color: #e7a761;
    color: #000;
    padding: 0.2rem 0.6rem;
    border-radius: 3rem;
    margin-top: 8px;
  }
}

/* 顶部导航栏样式 */
.top-nav {
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0rem 0.5rem;
  border-radius: 1rem;
  margin-bottom: 1rem;
  position: relative;
  z-index: 10;

  /* 核心：横向滚动 + 隐藏滚动条 */
  overflow-x: auto;       /* 允许横向滚动 */
  overflow-y: hidden;     /* 禁止纵向滚动 */
  white-space: nowrap;    /* 禁止子元素换行 */
  flex-wrap: nowrap;      /* 强制不换行 */
  
  /* 隐藏滚动条（兼容所有浏览器） */
  scrollbar-width: none;  /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }

  .nav-item {
    display: flex;
    align-items: center;
    padding: 0.4rem 1rem;
    border-radius: 0.3rem;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #363022;
    margin-right: 1rem;
    
    /* 关键：不压缩宽度 */
    flex-shrink: 0;

    span {
      color: #929292;
      font-size: 0.8rem;
      margin-right: 0.3rem;
    }

    &.active {
      background-color: #5c4c28;

      span {
        color: #e7b58e;
      }
    }
  }

  .dropdown-icon {
    color: #929292;
    font-size: 0.7rem;
    transition: transform 0.3s ease;
    cursor: pointer;

    &.rotate {
      transform: rotate(180deg);
    }
  }
}

/* 分类标签样式 */
.category-tabs {
  display: flex;
  overflow-x: auto;
  padding: 0rem 0;
  margin-bottom: 1rem;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .category-item {
    padding: 0.3rem 1rem;
    margin-right: 0.5rem;
    border-radius: 2rem;
    // background-color: rgba(255, 255, 255, 0.1);
    color: #929292;
    font-size: 0.8rem;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.3s ease;

    &.active {
      // background: linear-gradient(to bottom, #362c2b, #241d25);
      color: #e7b58e;
    }
  }
}

/* 直播列表样式 */
.live-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;

  .live-item {
    border-radius: 1rem;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    }

    .live-image-container {
      position: relative;
      width: 100%;
      padding-top: 100%;

      /* 1:1 比例 */
      .live-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 1rem;
        overflow: hidden;

        ::v-deep .van-image__img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }

      .live-tag {
        position: absolute;
        top: 0.5rem;
        left: 0.5rem;
        display: inline-block;
        padding: 0.2rem 0.5rem;
        border-radius: 1rem;
        font-size: 0.6rem;
        font-weight: bold;
        img {
          width: 25px;
        }
        // &.live {
        //   background-color: #ff0000;
        //   color: #fff;
        // }
      }

      .live-viewers {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        color: #fff;
        font-size: 0.7rem;
        display: flex;
        align-items: center;
        // background-color: rgba(0, 0, 0, 0.6);
        padding: 0.2rem 0.5rem;
        border-radius: 1rem;

        ::v-deep .van-icon {
          margin-right: 0.2rem;
        }
      }

      .live-username {
        position: absolute;
        bottom: 0.5rem;
        left: 0.5rem;
        color: #fff;
        font-size: 0.8rem;
        // background-color: rgba(0, 0, 0, 0.6);
        padding: 0.2rem 0.5rem;
        border-radius: 1rem;
      }
    }
  }
}
</style>
